import type { TFunction } from "i18next";

import { getConfigActionColumn, getConfigStatusColumn } from "features/shared/lib/technical-config-tab/tableHeaders";
import { getTableTypicalColumn, tableRoundedValueTransformation } from "utils/components";

import type { WindowTypeGroup } from "../model/types";
type WindowGroupTableHeaderOptions = {
  onConfigure: (group: WindowTypeGroup) => void;
  t: TFunction;
};

export const getWindowGroupTableHeaders = ({ onConfigure, t }: WindowGroupTableHeaderOptions) => [
  getTableTypicalColumn({
    dataKey: "userDefinedType",
    isReadOnly: true,
    label: t("TechnicalData.windows.columns.userDefinedType"),
  }),
  getTableTypicalColumn({
    dataKey: "surfaceCount",
    isReadOnly: true,
    label: t("TechnicalData.windows.columns.surfaceCount"),
    valueTransformation: (row: WindowTypeGroup) => tableRoundedValueTransformation(row.surfaceCount),
  }),
  getTableTypicalColumn({
    dataKey: "totalArea",
    isReadOnly: true,
    label: t("TechnicalData.windows.columns.totalArea"),
    valueTransformation: (row: WindowTypeGroup) => tableRoundedValueTransformation(row.totalArea),
  }),
  getConfigStatusColumn<WindowTypeGroup>({
    configuredLabel: t("TechnicalData.windows.hasConfig"),
    dataKey: "hasTechnology",
    isConfigured: (row) => row.hasTechnology,
    label: t("TechnicalData.windows.columns.configStatus"),
    notConfiguredLabel: t("TechnicalData.windows.noConfig"),
  }),  getConfigActionColumn<WindowTypeGroup>({
    configureLabel: t("TechnicalData.windows.columns.config"),
    minWidth: "4.5rem",
    onConfigure,
  }),
];
